import { render, staticRenderFns } from "./ReviewCreatives.vue?vue&type=template&id=1816e590&scoped=true"
import script from "./ReviewCreatives.vue?vue&type=script&lang=js"
export * from "./ReviewCreatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1816e590",
  null
  
)

export default component.exports